<template>
  <div class="panel panel-default">
    <div class="panel-body panel-info">
      <table class="table">
        <thead>
        <tr>
          <template v-if="input">

            <td v-for="(stationId,key) in input">
              <select-station-row
                  v-bind:prefecture_id="prefecture_id"
                  v-model="input[key]"
                  v-bind:station_id="input[key]"
                  v-bind:stationKey="key"
                  @update="update"
              ></select-station-row>
            </td>
          </template>

        </tr>
        </thead>
      </table>
    </div>
  </div>
</template>
<script>

export default {
  props: ['prefecture_id', 'station_ids'],
  data () {
    return {
      input: []
    }
  },
  created: function () {
    this.input = this.station_ids
    if (this.input && this.input.length === 0) {
      this.input = ['']
    }
  },
  watch: {
    'input': function (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    update: function (data) {
      this.input[data.key] = data.stationId
      this.$emit('input', this.input)
    }
  },
  components: {
    'select-station-row': require('./SelectStationRow.vue')
  }
}
</script>



// WEBPACK FOOTER //
// SelectStation.vue?b10dedce